import {
  Droplets,
  Wrench,
  ShieldCheck,
  Activity,
  Factory,
  Settings,
} from "lucide-react";

import waterAtmCity from "../images/arosia water New Alipore.jpg";
import waterAtmSolar from "../images/PHOTO-2022-10-29-13-33-16(1).jpg";
import wat from "../images/wat.jpg";
import jsw from "../images/client/jsw.png";
import coal from "../images/client/coal.png";
import iocl from "../images/client/iocl.png";
import iiest from "../images/client/iiest.png";
import grse from "../images/client/grse.png";
import jbj from "../images/client/jbj.png";
import drop from "../images/drop.jpg";
import waterAtmForest from "../images/kahamar orissa.jpeg";
import chlorinationPlant from "../images/chlorination.jpeg";
import dashboardPreview from "../images/dashboard1.png";
import heroWaterPlant from "../images/hero-water-plant.png";
import video1 from "../videos/water-flow.mp4";
import chlorination from "../videos/chlorination.mp4";
import future from "../images/future.jpg";
import ai from "../images/ai.jpg";
import wave from "../images/wave.jpg";
import smart from "../images/smart.jpg";
import waterr from "../images/waterr.jpg";
import water from "../images/water.png";
import client from "../images/client.jpg";
import waterDash from "../images/waterdash.png";
import engineer from "../images/engineer.jpg";
import earth from "../images/earth.jpg";
import sustainability from "../images/sustainability.jpg";
import booster from "../images/booster.png";
import brics from "../images/awards/brics.jpg";
import wti from "../images/awards/wti.jpg";
import un from "../images/awards/un.jpg";
import ftifc from "../images/awardlogo/ftifc.png";
import qualcom from "../images/awardlogo/qualcom.png";
import gwp from "../images/awardlogo/gwp.png";
import one from "../images/tech/1.jpg";
import two from "../images/tech/2.jpg";
import three from "../images/tech/3.jpg";
import four from "../images/tech/4.jpg";
import five from "../images/tech/5.jpg";
import six from "../images/tech/6.jpg";
import seven from "../images/tech/7.jpg";
import eight from "../images/tech/8.jpg";
import singapore from "../images/awards/singapore.jpg";
import leaders from "../images/awards/leaders.jpeg";
import kiosk from "../images/kiosk.png";
import cisco from "../images/awards/cisco.jpg";
import she from "../images/awards/she.jfif";
import tata from "../images/client/tata.png";
import watertech from "../images/watertech.jpg";
import dashboard5 from "../images/dashboard5.jpg";
import dashboard4 from "../images/dashboard4.jpg";
import dashboard2 from "../images/dashboard2.jpg";
import dashboard from "../images/dashboard.png";
import goi from "../images/client/goi.jpg";
import news from "../images/news.jpg";
import dashboard1 from "../images/dashboard1.png";
import testing from "../images/testing.jpg";
import glass from "../images/glass.jpg";
import projects from "../images/projects.jpg";
import hand from "../images/hand.jpg";
import fun from "../images/fun.png";
import lady from "../images/lady.png";
import ciscoa from "../images/awardlogo/cisco.png";
import bricsa from "../images/awardlogo/brics.png";
import wtia from "../images/awardlogo/wti.jpg";
import una from "../images/awardlogo/un.png";
import singaporea from "../images/awardlogo/siww.png";
import leadersa from "../images/awardlogo/lot.png";
import bayer from "../images/awardlogo/bayer.png";
import slt from "../images/awardlogo/slt.png";
import watertreatment from "../images/watertreatment.png";  
import gist from "../images/awardlogo/gist.jpg";
import  rituparna from "../images/founders/Rituparna Das.jpg";
import navin from "../images/founders/Navin Gupta.jpg";
import jyotsna from "../images/founders/jyotsna.jpg";
import unp from "../images/news/un.jpg";
import cup from "../images/cup.png";
import stand from "../images/stand.png";
export const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Solutions", path: "/solutions" },
  { label: "Projects", path: "/projects" },
  { label: "Monitoring", path: "/monitoring" },
  { label: "Contact", path: "/contact" },
];

export const stats = [
  { value: "450+", label: "Water Systems & Impact Points" },
  { value: "IoT", label: "Smart Monitoring Ready" },
  { value: "24/7", label: "Remote Visibility Support" },
  { value: "AMC", label: "Operations & Service Support" },
];

export const services = [
  {
    title: "Water ATM Solutions",
    desc: "Smart water ATM systems for communities, institutions, public spaces, and commercial locations with dispensing, payment, and remote monitoring support.",
    icon: Droplets,
  },
  {
    title: "Pump Systems",
    desc: "Supply, integration, maintenance, and performance support for booster pumps, pressure systems, raw water pumps, and distribution pumps.",
    icon: Wrench,
  },
  {
    title: "Water Treatment Solutions",
    desc: "Customized treatment systems including filtration, RO, UV, chlorination, iron removal, and integrated purification solutions for safe water delivery.",
    icon: ShieldCheck,
  },
  {
    title: "Online Water Monitoring",
    desc: "Real-time monitoring for parameters like Bacteria, pH, TDS, flow, pressure, tank levels, and water quality with dashboard connectivity.",
    icon: Activity,
  },
  {
    title: "Wastewater Solutions",
    desc: "Wastewater treatment, reuse, discharge management, and decentralized wastewater systems for residential, industrial, and institutional use.",
    icon: Factory,
  },
  {
    title: "Integrated Service Support",
    desc: "End-to-end installation, operations, AMC, repairs, spare support, and field service for complete water infrastructure systems.",
    icon: Settings,
  },
];

export const projectCards = [
  {
    title: "Urban Refill Water ATM",
    desc: "Compact and user-friendly refill water ATM designed for city environments, institutions, and public access points.",
    image: waterAtmCity,
  },
  {
    title: "Solar-Powered Kiosk",
    desc: "Resilient outdoor drinking water kiosk with solar integration for sustainable operation in remote and semi-urban areas.",
    image: waterAtmSolar,
  },
  {
    title: "Remote Deployment",
    desc: "Protected kiosk deployment built for eco-tourism and rural locations where dependable clean drinking water is essential.",
    image: waterAtmForest,
  },
  {
    title: "Chlorination & Dosing Unit",
    desc: "Automated treatment support system for chlorination, dosing control, and safer water quality management.",
    image: chlorinationPlant,
  },
];

export const strengths = [
  "Custom-engineered water and wastewater infrastructure solutions",
  "IoT-enabled monitoring, automation, and dashboard integration",
  "Field deployment, commissioning, and maintenance support",
  "Scalable systems for governments, institutions, communities, and industries",
  "Integrated hardware, software, service, and performance support",
];

export const monitoringFeatures = [
  {
    title: "Live Reporting",
    desc: "Track site-level performance, water dispensed, revenue, and key operating indicators from a centralized dashboard.",
  },
  {
    title: "Water Quality Insights",
    desc: "Monitor TDS, pH, flow, and treatment performance to support reliable safe water delivery.",
  },
  {
    title: "Master Site View",
    desc: "Compare multiple sites and understand operational performance across deployments from one interface.",
  },
  {
    title: "Decision Support",
    desc: "Use reports, trends, and alerts to improve maintenance planning and system efficiency.",
  },
];

export const gallery = [
  { title: "Urban Water ATM Installation", image: waterAtmCity },
  { title: "Solar-Powered Drinking Water Kiosk", image: waterAtmSolar },
  { title: "Remote Site Water ATM", image: waterAtmForest },
  { title: "Chlorination & Dosing System", image: chlorinationPlant },
  { title: "Live Monitoring Dashboard", image: dashboardPreview },
  { title: "Community Refill Access", image: waterAtmCity },
];

export const assets = {
  engineer,
  waterDash,
  water,
  heroWaterPlant,
  waterAtmCity,
  waterAtmSolar,
  waterAtmForest,
  chlorinationPlant,
  dashboardPreview,
  earth,
  sustainability,
  waterr,
  booster,
  ai,
  smart,
  wave,
  brics,
  wti,
  un,
  projects,
  singapore,
  leaders,
  kiosk,
  cisco,
  she,
  watertech,
  dashboard,
  dashboard1,
  dashboard2,
  dashboard4,
  dashboard5,
  testing,
  glass,
  hand,
  fun,
  lady,
  ciscoa,
  bricsa,
  wtia,
  una,
  singaporea,
  leadersa,
  bayer,
  slt,
  gist,
  navin,
  rituparna,
  jyotsna,
  cup,
  stand,
  client,
  news,
  video1,
  chlorination, 
  future,
  wat,
  drop,
  coal,
  jsw,
  iocl,
  jbj,
  iiest,
  tata,
  goi,
  grse,un,ftifc,
  qualcom,gwp,
  one,
  two,
  three,
  four, 
  five,
  six,
  seven,
  eight,
  watertreatment,
};